"use client";

import Link from "next/link";

export default function GlobalError({ error, reset }) {
  return (
    <html>
      <body className="h-screen flex flex-col items-center justify-center bg-gray-100">
        <h2 className="text-3xl font-bold text-red-600">Something went wrong!</h2>
        <p className="text-gray-500 mt-2">{error?.message || "An unexpected error occurred."}</p>
        <Link href='/'>
        <button
          onClick={() => {
              localStorage.clear(); // ✅ Local Storage Clear
              sessionStorage.clear(); // ✅ (Optional) Session Storage Clear
              setTimeout(() => {
                window.location.reload(); // ✅ Page Reload after clearing storage
              }, 100);
              // reset(); // ✅ Page Reset
            }}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
          >
          Try Again
        </button>
            </Link>
      </body>
    </html>
  );
}
